import Enum from './enum'

class TenderPublicationMode extends Enum
{
  constructor(value) {
    super(value);
  }
}

TenderPublicationMode.init({
  DEFERRED: 'deferred',
  NOW: 'now'
}, {
  DEFERRED: 'tender-publication-mode.deferred',
  NOW: 'tender-publication-mode.now'
});

export default TenderPublicationMode;
